// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Cysq","newExpiryDate":"styles_newExpiryDate__1H3Zb","footer":"styles_footer__3B0dK"};